import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {EnumerationService} from '../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';
import {ApplicationService} from '../services/application.service';

@Component({
  selector: 'app-viewer-folder-form',
  templateUrl: './viewer-folder-form.component.html',
  styles: []
})
export class ViewerFolderFormComponent extends ExcTranslation {

  @ViewChild('VCformfolderEdit', {read: ElementRef}) VCformfolderEdit!: ElementRef;
  @ViewChild('VCheadline', {read: ElementRef}) VCheadline!: ElementRef;
  @ViewChild('VCdesc', {read: ElementRef}) VCdesc!: ElementRef;

  constructor(
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  @Input()
  viewerActions: any;

  _editmode = false;

  get editmode(): boolean {
    return this._editmode;
  }

  _data: { headline: string; description: string; groupID: string; groupUPT: string }
    = {headline: '', description: '', groupID: '', groupUPT: ''};

  @Input()
  set data(incoming: { headline: '', description: '', groupID: '', groupUPT: '' }) {
    this.inputData = incoming;
  }

  _dataClone: { headline: string; description: string; groupID: string; groupUPT: string }
    = {headline: '', description: '', groupID: '', groupUPT: ''};

  get dataClone(): { headline: string; description: string; groupID: string; groupUPT: string } {
    return this._dataClone;
  }

  get inputData(): { headline: string; description: string; groupID: string; groupUPT: string } {
    return this._data;
  }

  set inputData(value: { headline: string; description: string; groupID: string; groupUPT: string }) {
    this._data = value;
    this._dataClone = this.appSvc.helperObj.clone(value);
  }

  get headline(): string {
    return this.dataClone.headline;
  }

  set headline(value: string) {
    this.dataClone.headline = value;
  }

  get description(): string {
    return this.dataClone.description;
  }

  set description(value: string) {
    this.dataClone.description = value;
  }

  changeEditmode(): void {
    this._editmode = !this._editmode;
    if (this.editmode) {
      this.initial();
    }
  }

  initial(): void {
    this._dataClone = this.appSvc.helperObj.clone(this.inputData);
  }

  resetForm(cancel = false): void {
    if (!cancel) {
      if (this.appSvc.helperObj.changed(this.inputData, this.dataClone)) {
        this.initial();
      }
    } else {
      this.changeEditmode();
    }
  }
}
